// src/utils/constants.js

/**
 * GITHUB_USERNAME
 * Your GitHub username, used to fetch project and stats data.
 */
export const GITHUB_USERNAME = 'Suganth46';

/**
 * FEATURED_PROJECTS
 * Add the exact names of your best GitHub repositories here.
 */
export const FEATURED_PROJECTS = [
  'Blog_App',
  'Quiz_Game',
  'Kubernetes-Deployment-Strategies',
  'Lan_Based_Software_Installation',
  'Task_Manager_Java_Console',
];

/**
 * SKILL_CATEGORIES
 * A structured list of your skills, organized by category.
 */
export const SKILL_CATEGORIES = [
  {
    title: 'Languages',
    items: [
      { name: 'Java', icon: 'java.svg' },
      { name: 'Python', icon: 'python.svg' },
      { name: 'JavaScript', icon: 'javascript.svg' },
      { name: 'C', icon: 'c.svg' },
    ],
  },
  {
    title: 'Backend & Frameworks',
    items: [
      { name: 'Spring Boot', icon: 'spring.svg' },
      { name: 'Spring Security', icon: 'spring.svg' },
      { name: 'JWT', icon: 'java.svg' },
      { name: 'Hibernate/JPA', icon: 'java.svg' },
      { name: 'JDBC', icon: 'java.svg' },
    ],
  },
  {
    title: 'Databases',
    items: [
      { name: 'MySQL', icon: 'mysql.svg' },
      { name: 'PostgreSQL', icon: 'postgresql.svg' },
      { name: 'MongoDB', icon: 'mongodb.svg' },
    ],
  },
  {
    title: 'Devops & Cloud',
    items: [
      { name: 'Docker', icon: 'docker-svgrepo-com.svg' },
      { name: 'Kubernetes', icon: 'kubernetes-svgrepo-com.svg' },
      { name: 'Jenkins', icon: 'jenkins-svgrepo-com.svg' },
      { name: 'Terraform', icon: 'terraform-icon-svgrepo-com.svg' },
      { name: 'Ansible', icon: 'ansible-svgrepo-com.svg' },
      { name: 'Amazon (EC2, S3, VPC, EKS, ECS, ECR)', icon: 'aws-svgrepo-com.svg' }
    ],
  },
  {
    title: 'Web & Frontend',
    items: [
      { name: 'HTML', icon: 'html5.svg' },
      { name: 'CSS', icon: 'css3.svg' },
    ],
  },
  {
    title: 'Tools & Tech',
    items: [
      { name: 'Postman', icon: 'postman.svg' },
      { name: 'Git', icon: 'git.svg' },
      { name: 'GitHub', icon: 'github-142-svgrepo-com.svg' },
      { name: 'GitHub Actions', icon: 'github-142-svgrepo-com.svg' },
      { name: 'Linux', icon: 'linux-svgrepo-com.svg' },
      { name: 'Maven', icon: 'maven-svgrepo-com.svg' },
      { name: 'Prometheus', icon: 'prometheus-svgrepo-com.svg' },
      { name: 'Grafana', icon: 'grafana-svgrepo-com.svg' }
    ],
  },
];
